import {
  GetPreferencesForTableTextQuery,
  GetPreferencesForTableTextQueryVariables
} from '@data/__generated__/types.main'
import useWebsiteId from '@hooks/useWebsiteId'
import {useApolloQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function useDeliveryType() {
  const websiteId = useWebsiteId()

  const {userPreferences} = useApolloQuery<
    GetPreferencesForTableTextQuery,
    GetPreferencesForTableTextQueryVariables
  >({
    query: gql`
      query getPreferencesForTableText($websiteId: ID!) {
        userPreferences(websiteId: $websiteId) {
          _id
          deliveryType
        }
      }
    `,
    variables: {
      websiteId
    }
  })

  return userPreferences.deliveryType
}
